import { render, staticRenderFns } from "./OrganizationSecurityRoleTable.vue?vue&type=template&id=34c7b9a5&"
import script from "./OrganizationSecurityRoleTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationSecurityRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports